import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import favicon from './assets/images/favicon2.png';

// Ensure the site uses favicon2.png as the favicon at runtime.
const setFavicon = (href) => {
  try {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = href;
  } catch (e) {
    // fail silently if document not available (e.g., SSR)
    // eslint-disable-next-line no-console
    console.warn('Could not set favicon', e);
  }
};

setFavicon(favicon);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
